import React, {useState} from 'react';
import DatasetInfo from './DatasetInfo';
import styles from '../Style/DownloadTab.module.scss';
import {DownloadInfoItem} from '../../../../types/analytics';
import {DownloadCheckboxKey} from '../../../../utils/common';
import {isEmpty} from 'underscore';
import {DATASET_CATEGORIES} from '../../../../utils/filterBestDataset';
import {message} from 'antd';
import IconWaves from '../../../../assets/icon/Waves.svg'
import IconWave from '../../../../assets/icon/Wave.svg'
import IconWind from '../../../../assets/icon/Wind.svg'
import useCartStore from "../../../../store/cartStore";
import useDeleteShoppingItemMutation from "../../../../queries/useDeleteShoppingItemMutation";

export default function DownloadTab(props: {
  list: DownloadInfoItem[];
  activePointId?: string;
  coords: number[];
  onMeshControl: (value: string) => any;
  setDatasetIsOfflineWarningVisible: React.Dispatch<React.SetStateAction<boolean>>;
  onAddProductToCart: (
    item: DownloadInfoItem,
    pointName: string,
    category: string,
    coordinates: number[]
  ) => Promise<boolean>;
}) {
  const shoppingItems = useCartStore(state => state.shoppingItems);
  const deleteShoppingItemMutation = useDeleteShoppingItemMutation();

  const [disableDownload, setDisableDownload] = useState(false);

  function filterDownloadDatasetItem(key: string) {
    if (isEmpty(props.list)) {
      return;
    }
    return props.list.find((l) => l.radioKey === key);
  }

  async function triggerRemoveProductFromCart(
    pointName: string,
    category: string
  ) {
    const shoppingItemsPerPoint = shoppingItems[pointName];
    if (!shoppingItemsPerPoint) return;

    const shoppingItem = shoppingItemsPerPoint[category];
    if (shoppingItem?.order_id) {
      try {
        const response = await deleteShoppingItemMutation.mutateAsync(shoppingItem.order_id);
        if (!response.Result || response.Result !== 'OK') {
          message.warn('Failed to delete the item from shopping cart');
        }
      } catch (error) {
        message.warn('Failed to delete the item from shopping cart');
      }
    }
  }

  return (
    <div className={styles.downloadRoot}>
      <div className={styles.downloadBox}>
        <DatasetInfo
          downloadItems={props.list}
          label={DATASET_CATEGORIES.WAVES}
          item={filterDownloadDatasetItem(DownloadCheckboxKey.SW)!}
          coords={props.coords}
          onMeshControl={props.onMeshControl}
          onAddProductToCart={props.onAddProductToCart}
          onRemoveProductFromCart={triggerRemoveProductFromCart}
          disableDownload={disableDownload}
          setDisableDownload={setDisableDownload}
          icon={<img src={IconWave} alt="Wave" width={'50px'} height={'50px'}/>}
          setDatasetIsOfflineWarningVisible={props.setDatasetIsOfflineWarningVisible}
          namePanel={DownloadCheckboxKey.SW}
        />
      </div>

      <div className={styles.downloadBox}>
        <DatasetInfo
          downloadItems={props.list}
          label={DATASET_CATEGORIES.OCEAN}
          item={filterDownloadDatasetItem(DownloadCheckboxKey.HD)!}
          coords={props.coords}
          onMeshControl={props.onMeshControl}
          onAddProductToCart={props.onAddProductToCart}
          onRemoveProductFromCart={triggerRemoveProductFromCart}
          disableDownload={disableDownload}
          setDisableDownload={setDisableDownload}
          icon={<img src={IconWaves} alt="Waves" width={'50px'} height={'50px'}/>}
          setDatasetIsOfflineWarningVisible={props.setDatasetIsOfflineWarningVisible}
          namePanel={DownloadCheckboxKey.HD}
        />
      </div>

      <div className={styles.downloadBox}>
        <DatasetInfo
          downloadItems={props.list}
          label={DATASET_CATEGORIES.ATMOSPHERE}
          item={filterDownloadDatasetItem(DownloadCheckboxKey.Wind)!}
          coords={props.coords}
          onMeshControl={props.onMeshControl}
          onAddProductToCart={props.onAddProductToCart}
          onRemoveProductFromCart={triggerRemoveProductFromCart}
          disableDownload={disableDownload}
          setDisableDownload={setDisableDownload}
          icon={<img src={IconWind} alt="Wind" width={'50px'} height={'50px'}/>}
          setDatasetIsOfflineWarningVisible={props.setDatasetIsOfflineWarningVisible}
          namePanel={DownloadCheckboxKey.Wind}
        />
      </div>
    </div>
  );
}
